'use client'
import React, { useState } from 'react';

const TermsPage = () => {
  const [lang, setLang] = useState<string>('en');

  // Mapping languages to your PDF file paths
  const pdfDocs: any = {
    'fr': '/pdf/gss_fr_terms.pdf',
    'en': '/pdf/gss_en_terms.pdf',
    'de': '/pdf/gss_de_terms.pdf',
  };

  const onSelectLanguage = (code: string) => {
    setLang(code);
  };

  return (
    <div className="min-h-screen bg-zinc-900 text-white p-4 flex flex-col">
      <div className='w-full flex justify-end mb-4'>
        <select 
          className='bg-zinc-800 text-white text-lg p-2 rounded border border-zinc-700 cursor-pointer hover:border-orange-300 outline-none'
          onChange={(e) => onSelectLanguage(e.target.value)}
          value={lang}
        >
          <option value="fr">Français (FR)</option>
          <option value="en">English (EN)</option>
          <option value="de">Deutsch (DE)</option>
        </select>
      </div>

      {/* PDF Viewer Container */}
      <div className="flex-grow w-full max-w-5xl mx-auto bg-white rounded-lg overflow-hidden shadow-2xl">
        <iframe
          src={`${pdfDocs[lang]}#toolbar=0`} 
          title="Terms and Conditions"
          className="w-full h-full min-h-[80vh] h-[70vh]"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default TermsPage;